export const selectVpnStatus = (store) => store.nordVpn.vpnStatus;
export const selectVpnEmail = (store) => store.nordVpn.email;
